export default __webpack_public_path__ + "media/quote/reel-play-button-69ec0e4c.svg";